(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$http', 'Company', '$location', '$rootScope'];

    function HomeController($scope, Principal, LoginService, $state, $http, Company, $location, $rootScope) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        $scope.$on('activationSuccess', function (event, data) {
            getAccount();
        });


        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {

                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;

                if (account != null && vm.isAuthenticated() === true) {
                    if (Principal.hasAnyAuthority(['ROLE_USER'])) {
                        if (account.activated === true || $rootScope.activated === true) {
                            $state.go('instances');
                        } else {
                           // $state.go('instance-dbh');
                            $state.go('verify');
                        }
                    } else if (Principal.hasAnyAuthority(['ROLE_ADMIN'])) {
                        $state.go('instance-management');
                    }
                }
                else {
                    var obj = $location.search();

                    if (obj.company && obj.instance) {


                        $state.go('company');
                    }
                    else {
                        $state.go('signin');
                    }

                }
            });
        }

        function register() {
            $state.go('register');
        }

        $scope.completeCompany = function (company) {
            company.completed = true;
            Company.update(company);
            $location.path('/instance-dbh');
        }
    }
})();
